export default{init:function(){return this.xf['@@transducer/init']();},result:function(result){return this.xf['@@transducer/result'](result);}};